import { Component, OnInit, Renderer2, Inject, AfterViewInit, ViewChild } from '@angular/core';
import { Router } from "@angular/router"
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { DOCUMENT } from '@angular/common';
import { AuthenticationService } from '@services/security';
import { VerifyCodeModel } from '@shared/security/verify-code.model';
import { AppConsts } from '@shared/app-consts';
import { RecaptchaService } from '@services/security/recaptcha-service';



// Parité V1 : CircleTimerComponent venait de '@flxng/circle-timer' — remplacé par le composant vendored local (même API).
import { CircleTimerComponent } from '@shared/vendored/circle-timer';
import { SendCodeModel } from '@shared/security/send-code.model';
@Component({
  standalone: false,
  selector: 'app-twofactor-verifycode',
  templateUrl: './verify-code.component.html',
  styleUrls: ['./verify-code.component.scss']
})
export class TwoFactorVerifyCodeComponent implements OnInit, AfterViewInit {
  @ViewChild('timer', { static: false }) timer: CircleTimerComponent;
  startDate = Date.now();
  duration = 60 * 1000; // 1 minute
  isError: boolean;
  submitted: boolean;
  IsTwoFactorRememberClient: boolean;
  receivedToken: string;
  verifyCodeForm: FormGroup;
  email: string;
  sended:boolean;
  get f() { return this.verifyCodeForm.controls; }
  submitWithCaptcha = RecaptchaService.submitWithCaptcha;


  constructor(private service: AuthenticationService,
    private router: Router,
    public formBuilder: FormBuilder,
    @Inject(DOCUMENT) private _document) {
  }


  ngOnInit() {
    this.sended=false;
    this.buildForm();
    this.email = sessionStorage.getItem(AppConsts.CRMClientCurrentEmail);
    if (!this.email || this.email == null || this.email.trim() === '')
      this.router.navigate(['login']);
  }
  buildForm() {
    this.verifyCodeForm = this.formBuilder.group({
      receivedToken: ["", Validators.required]
    });
  }

  handleValidSubmit = (event) => {
    this.submitWithCaptcha(this.onCodeCompleted.bind(this), event, "submit");
  }

  ngAfterViewInit(): void {
    this.timer.start(this.startDate);
  }

  onCodeCompleted($event, recaptchaToken) {
    this.submitted = true;
    

    let model = new VerifyCodeModel();
    model.Code = $event;
    model.Email = this.email;
    model.Provider = sessionStorage.getItem(AppConsts.CRMClientCurrentTwoFactorProvider);
    model.RememberClient = true;
    model.RecaptchaToken = recaptchaToken;
    const rememberMe = sessionStorage.getItem(AppConsts.REMEMBER_ME);
    this.service.verifyCodeTwofactor(model).subscribe((response: any) => {
      if (response && response != null) {
        const isRequiredBiTwoFactorAuthentication = sessionStorage.getItem(AppConsts.BudgetInsight.requiredAuthenticationBiState);
        if (!JSON.parse(isRequiredBiTwoFactorAuthentication)) {
          this.service.signIn(response, model.Email, rememberMe);
          localStorage.setItem(AppConsts.IsTwoFactorRememberClient, "true");
        }
        else {
          sessionStorage.setItem(AppConsts.BudgetInsight.isAuthenticationBiState, "true");
        }
        this.service.redirectToReturnUrl("");
      }
      else
        this.isError = true;
    });
  }

  backToSendCode() {
    this.router.navigate(['login/send-code']);
  }
  onTimeComplete(): void {
    setTimeout(() => {
      document.getElementById('timerContainer').style.display= "none";
      this.sended=true;
    }, 1000);

  }
  reSendCode() {
    document.getElementById('timerContainer').style.display = "unset";
    this.sended=false;
    this.isError = false;
    let model = new SendCodeModel();
    model.SelectedProvider = sessionStorage.getItem(AppConsts.CRMClientCurrentTwoFactorProvider);
    model.Email = sessionStorage.getItem(AppConsts.CRMClientCurrentEmail);
    this.service.sendCodeTwofactor(model).subscribe(
      (response: any) => {
        if (response) {
          this.timer.init();
          this.timer.start();
        }
      });
  }
}
